/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseMetaData
 */
export interface DatabaseMetaData {
    /**
     * 
     * @type {string}
     * @memberof DatabaseMetaData
     */
    anonymousUserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseMetaData
     */
    acceptRegisteredUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseMetaData
     */
    acceptAnonymousUsers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseMetaData
     */
    anonymousAccessRequiresAuthentication?: boolean;
}

/**
 * Check if a given object implements the DatabaseMetaData interface.
 */
export function instanceOfDatabaseMetaData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseMetaDataFromJSON(json: any): DatabaseMetaData {
    return DatabaseMetaDataFromJSONTyped(json, false);
}

export function DatabaseMetaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseMetaData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anonymousUserId': !exists(json, 'anonymousUserId') ? undefined : json['anonymousUserId'],
        'acceptRegisteredUsers': !exists(json, 'acceptRegisteredUsers') ? undefined : json['acceptRegisteredUsers'],
        'acceptAnonymousUsers': !exists(json, 'acceptAnonymousUsers') ? undefined : json['acceptAnonymousUsers'],
        'anonymousAccessRequiresAuthentication': !exists(json, 'anonymousAccessRequiresAuthentication') ? undefined : json['anonymousAccessRequiresAuthentication'],
    };
}

export function DatabaseMetaDataToJSON(value?: DatabaseMetaData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anonymousUserId': value.anonymousUserId,
        'acceptRegisteredUsers': value.acceptRegisteredUsers,
        'acceptAnonymousUsers': value.acceptAnonymousUsers,
        'anonymousAccessRequiresAuthentication': value.anonymousAccessRequiresAuthentication,
    };
}

